import { FocusTrap } from 'focus-trap-react';
import type { FC, ReactNode } from 'react';
import React from 'react';
import { useCloseHandlersWithoutDuplicatedCalls } from '~/Utils/Hooks/useCloseHandlersWithoutDuplicatedCalls';
import { ScrollLock } from '~/Utils/ScrollLock/ScrollLock';

export interface ModalWrapperProps {
    isScrollLocked: boolean;
    isFocusTrapActive: boolean;
    children: (buttonClickClose: () => void) => ReactNode;
    close: () => void;
    shouldHideMainScrollBar?: boolean;
}

export const ModalWrapper: FC<ModalWrapperProps> = props => {
    const { isFocusTrapActive, isScrollLocked, children, close, shouldHideMainScrollBar } = props;

    const { focusTrapDeactivationClose, buttonClickClose } = useCloseHandlersWithoutDuplicatedCalls(
        close,
        isFocusTrapActive
    );

    return (
        <>
            <ScrollLock isLocked={isScrollLocked} shouldHideMainScrollBar={shouldHideMainScrollBar} />
            <FocusTrap
                active={isFocusTrapActive}
                focusTrapOptions={{
                    clickOutsideDeactivates: true,
                    escapeDeactivates: true,
                    onDeactivate: focusTrapDeactivationClose,
                }}
            >
                {/*
                 * TabIndex is needed here, because by default, when clicking on non-focusable element inside modal
                 * browser focuses body element: https://github.com/focus-trap/focus-trap/issues/587.
                 */}
                <div tabIndex={-1}>{children(buttonClickClose)}</div>
            </FocusTrap>
        </>
    );
};
